module.exports = __webpack_public_path__ + "img/Photo_3__Third_Canal_988_8_14.3f584d25.jpg";